export let appCalendar = "TleiQe";
export default {appCalendar};